import type { RegionDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, RegionDto[]>({
      method: 'GET',
      url: '/api/app/region',
    },
    { apiName: this.apiName,...config });
}